import React from 'react';
import Layout from '../components/Layout';
import './Screenshots.css';


const screenshots = [
  {
    src: '/screenshots/1.png',
    alt: 'Tonometer Scan Dashboard - AI-powered blood pressure monitoring interface. Start scanning.'
  },
  {
    src: '/screenshots/2.png',
    alt: 'Tonometer Scan Dashboard - AI-powered blood pressure monitoring interface. Point camera to the tonometer.'
  },
  {
    src: '/screenshots/3.png',
    alt: 'Tonometer Scan Dashboard - AI-powered blood pressure monitoring interface. Check result and add to the Apple Health.'
  }
];

const Screenshots = () => {

  return (
    <Layout>
      <section className="screenshots-section">
        <h2>Explore Tonometer Scan</h2>
        <p>See our app in action</p>
        
        <div className="screenshots-grid">
          {screenshots.map((screenshot, index) => (
                <div className="screenshot-card" key={index}>
                  <img 
                    src={screenshot.src} 
                    alt={screenshot.alt} 
                  />
                </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default Screenshots;